var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-row",
        { attrs: { gutter: 10 } },
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("section-box", {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.scholarInterestsLoading,
                    expression: "scholarInterestsLoading",
                  },
                ],
                scopedSlots: _vm._u([
                  {
                    key: "title",
                    fn: function () {
                      return [
                        _c("p", { staticStyle: { "font-size": "18px" } }, [
                          _vm._v("研究兴趣"),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "main",
                    fn: function () {
                      return [
                        _vm.riverData && _vm.riverData.legend.length > 0
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  width: "100%",
                                  height: "334px",
                                  position: "relative",
                                },
                              },
                              [
                                _c("scholar-interest-chart", {
                                  attrs: { data: _vm.riverData },
                                }),
                              ],
                              1
                            )
                          : _c(
                              "div",
                              { staticStyle: { height: "334px" } },
                              [_c("el-empty")],
                              1
                            ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("section-box", {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.scholarTrendLoading,
                    expression: "scholarTrendLoading",
                  },
                ],
                staticStyle: { "margin-top": "9px" },
                scopedSlots: _vm._u([
                  {
                    key: "title",
                    fn: function () {
                      return [
                        _c("p", { staticStyle: { "font-size": "18px" } }, [
                          _vm._v("领域前沿度分析"),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "main",
                    fn: function () {
                      return [
                        _vm.trendData &&
                        _vm.trendData.years != null &&
                        _vm.trendData.years.length > 0
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  height: "334px",
                                  width: "100%",
                                  position: "relative",
                                },
                              },
                              [
                                _c("scholar-trend", {
                                  attrs: { data: _vm.trendData },
                                }),
                              ],
                              1
                            )
                          : _c(
                              "div",
                              { staticStyle: { height: "334px" } },
                              [_c("el-empty")],
                              1
                            ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("section-box", {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.scholarWordLoading,
                    expression: "scholarWordLoading",
                  },
                ],
                scopedSlots: _vm._u([
                  {
                    key: "title",
                    fn: function () {
                      return [
                        _c("p", { staticStyle: { "font-size": "18px" } }, [
                          _vm._v("研究热词"),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "main",
                    fn: function () {
                      return [
                        _vm.hotWordData && _vm.hotWordData.length > 0
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  height: "334px",
                                  width: "100%",
                                  position: "relative",
                                },
                              },
                              [
                                _c("scholar-hot-word", {
                                  attrs: {
                                    "hot-data": _vm.hotWordData,
                                    domId: "detail",
                                  },
                                }),
                              ],
                              1
                            )
                          : _c(
                              "div",
                              { staticStyle: { height: "334px" } },
                              [_c("el-empty")],
                              1
                            ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
              _c("section-box", {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.scholarChordLoading,
                    expression: "scholarChordLoading",
                  },
                ],
                staticStyle: { "margin-top": "9px" },
                scopedSlots: _vm._u([
                  {
                    key: "title",
                    fn: function () {
                      return [
                        _c("p", { staticStyle: { "font-size": "18px" } }, [
                          _vm._v("领域相关度分析"),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "main",
                    fn: function () {
                      return [
                        _vm.chordData && _vm.chordData.links.length > 0
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  height: "334px",
                                  width: "100%",
                                  position: "relative",
                                },
                              },
                              [
                                _c("scholar-chord", {
                                  attrs: { data: _vm.chordData },
                                }),
                              ],
                              1
                            )
                          : _c(
                              "div",
                              { staticStyle: { height: "334px" } },
                              [_c("el-empty")],
                              1
                            ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }